<template>
    <button
        class="lni-c-button--primary"
        type="button"
        @click="click"
        :disabled="!canSubmit"
    >{{ text }}</button>
</template>

<script>
import { mapGetters, } from 'vuex';
import framework from '../../framework';
/**
 *  The x-submit component.
 *  @module components/x-submit
 */


/**
 * The x-submit is basic submit button.
 */

export default {
    name: 'x-submit',
    props: {
        dataText: String,
        dataOnClickFunction: String,
    },
    mixins: [
        framework.mixins.abstractElement,
    ],
    mounted() {
        this.resetConfirmationCheckbox();
    },
    computed: {
        onClickFunction() {
            if (this.dataOnClickFunction) {
                return this.dataOnClickFunction;
            }

            if (this.nodeManifest && this.nodeManifest.attributes.onClickFunction) {
                let func = this.convertInteractionFunction(
                    this.nodeManifest.attributes.onClickFunction);
                if (func) {
                    return func;
                }
            }

            throw new Error('x-submit element requires an onClickFunction attribute');
        },
        ...mapGetters({
            canSubmit: 'canSubmit',
        }),
        text() {
            return this.getAttribute('text', 'Submit');
        },
    },
    methods: {
        resetConfirmationCheckbox() {
            // When loading this route, always uncheck the confirmation checkbox.
            // This needs to be rechecked each time before submitting.
            this.$store.commit(
                framework.storeConstants.MutationTypes.UpdateValue,
                {
                    id: 'chkConfirm',
                    valuesObject: [
                        {
                            value: false,
                        },
                    ],
                }
            );

            this.$store.commit(
                framework.storeConstants.MutationTypes.UpdateError,
                {
                    id: 'chkConfirm',
                    errorMessageObject: [
                        {
                            localErrorMessage: 'Please check this box if you want to proceed.',
                            globalErrorMessage:
                                'Confirmation: Please check this box if you want to proceed.',
                        },
                    ],
                }
            );
        },
        /**
         * Handles the click event.
         * @param {*} event the click event
         * @returns {void}
         */
        click(event) {
            event.preventDefault();
            let func = this.onClickFunction;
            func();
        },
    },
};

</script>



// WEBPACK FOOTER //
// source/components/x-submit/x-submit.vue